var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJukeboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 40q-1.2 0-2.1-.9Q4 38.2 4 37V11q0-1.2.9-2.1Q5.8 8 7 8h34q1.25 0 2.125.9T44 11v26q0 1.2-.875 2.1-.875.9-2.125.9Zm14.5-6.5q1.9 0 3.2-1.325Q26 30.85 26 29V18.1h3.6q.75 0 1.275-.525.525-.525.525-1.275 0-.75-.525-1.275-.525-.525-1.275-.525h-3.9q-.65 0-1.075.425Q24.2 15.35 24.2 16v9.3q-.5-.35-1.275-.575-.775-.225-1.425-.225-1.9 0-3.2 1.325Q17 27.15 17 29q0 1.85 1.3 3.175 1.3 1.325 3.2 1.325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJukeboxIcon);
export default __webpack_public_path__ + "static/media/jukebox-icon.5309876e1669c321b89ab4c0aca03a63.svg";
export { ForwardRef as ReactComponent };